import { useEffect, useRef, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { RegisterPage, GameBg, PageBody, CentreCol, RegisterCard } from './RegisterStyle';
import { FiArrowRight, FiMail } from 'react-icons/fi';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const handled = useRef(false);
  const [resendEmail, setResendEmail] = useState('');
  const [resendStatus, setResendStatus] = useState('idle'); // idle | sending | sent | error | already_active
  const [resendCooldown, setResendCooldown] = useState(0);
  const cooldownRef = useRef(null);

  useEffect(() => {
    return () => { if (cooldownRef.current) clearInterval(cooldownRef.current); };
  }, []);

  const handleResend = async () => {
    if (!resendEmail || resendCooldown > 0 || resendStatus === 'sending') return;
    setResendStatus('sending');
    try {
      const { data } = await axios.post('/api/resend_verification', { email: resendEmail });
      setResendStatus(data.alreadyActive ? 'already_active' : 'sent');
    } catch {
      setResendStatus('error');
    }
    setResendCooldown(60);
    cooldownRef.current = setInterval(() => {
      setResendCooldown(prev => {
        if (prev <= 1) { clearInterval(cooldownRef.current); return 0; }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }

    axios.get(`/api/verify_email/${token}`)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, []);

  return (
    <RegisterPage>
      <GameBg>
        <PageBody>
          <CentreCol>
            <RegisterCard>
              {status === 'loading' && (
                <>
                  <div className="card-top-icon" style={{ fontSize: 22 }}>⏳</div>
                  <h2 className="card-title">جارٍ التحقق…</h2>
                  <p className="card-subtitle">يرجى الانتظار.</p>
                </>
              )}

              {status === 'success' && (
                <>
                  <div className="card-top-icon" style={{ fontSize: 22 }}>✅</div>
                  <h2 className="card-title">تم تفعيل حسابك!</h2>
                  <p className="card-subtitle">
                    تم تفعيل حسابك بنجاح. يمكنك الآن تسجيل الدخول.
                  </p>
                  <Link
                    to="/login"
                    style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      gap: 6, marginTop: 8, color: '#c8a040', fontWeight: 600,
                      fontSize: 14, textDecoration: 'none',
                    }}
                  >
                    تسجيل الدخول <FiArrowRight size={14} />
                  </Link>
                </>
              )}

              {status === 'error' && (
                <>
                  <div className="card-top-icon" style={{ fontSize: 22 }}>❌</div>
                  <h2 className="card-title">رابط غير صالح</h2>
                  <p className="card-subtitle">
                    رابط التفعيل غير صالح أو منتهي الصلاحية. أدخل بريدك لإعادة الإرسال.
                  </p>

                  <div style={{ marginTop: 12, marginBottom: 8 }}>
                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                      <FiMail style={{ position: 'absolute', insetInlineStart: 12, color: '#555', fontSize: 14 }} />
                      <input
                        type="email"
                        placeholder="your@email.com"
                        value={resendEmail}
                        onChange={e => setResendEmail(e.target.value)}
                        style={{
                          width: '100%', padding: '10px 12px 10px 36px',
                          background: '#1a1a2e', border: '1px solid #333',
                          borderRadius: 8, color: '#e0d9cc', fontSize: 13,
                          outline: 'none', boxSizing: 'border-box',
                        }}
                      />
                    </div>

                    {resendStatus === 'sent' && (
                      <p style={{ color: '#4caf50', fontSize: 12, marginTop: 6 }}>✓ تم إرسال رابط التفعيل، تحقق من بريدك.</p>
                    )}
                    {resendStatus === 'already_active' && (
                      <p style={{ color: '#c8a040', fontSize: 12, marginTop: 6 }}>حسابك مفعّل بالفعل، يمكنك تسجيل الدخول.</p>
                    )}
                    {resendStatus === 'error' && (
                      <p style={{ color: '#e74c3c', fontSize: 12, marginTop: 6 }}>لم يتم العثور على البريد أو حدث خطأ، حاول مجدداً.</p>
                    )}

                    <button
                      onClick={handleResend}
                      disabled={!resendEmail || resendCooldown > 0 || resendStatus === 'sending'}
                      style={{
                        display: 'block', width: '100%', padding: '11px',
                        background: (!resendEmail || resendCooldown > 0) ? '#2a2a2a' : 'linear-gradient(90deg,#c0392b,#e74c3c)',
                        color: (!resendEmail || resendCooldown > 0) ? '#666' : '#fff',
                        border: 'none', borderRadius: 8, fontWeight: 700,
                        fontSize: 14, cursor: (!resendEmail || resendCooldown > 0) ? 'not-allowed' : 'pointer',
                        marginTop: 10, transition: 'all .2s',
                      }}
                    >
                      {resendStatus === 'sending'
                        ? 'جارٍ الإرسال…'
                        : resendCooldown > 0
                          ? `إعادة الإرسال (${resendCooldown}ث)`
                          : 'إرسال رابط التفعيل'
                      }
                    </button>
                  </div>

                  <Link
                    to="/register"
                    style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      gap: 6, marginTop: 8, color: '#c8a040', fontWeight: 600,
                      fontSize: 14, textDecoration: 'none',
                    }}
                  >
                    إنشاء حساب جديد <FiArrowRight size={14} />
                  </Link>
                </>
              )}
            </RegisterCard>
          </CentreCol>
        </PageBody>
      </GameBg>
    </RegisterPage>
  );
};

export default VerifyEmail;
